<script lang="ts" setup>
import ProductGrayButton from '~/components/products/ProductGrayButton.vue'
import ProductTextStrong from '~/components/products/ProductTextStrong.vue'
import type { ProductData } from '~/types/products'

const props = defineProps<{
  productData: ProductData
}>()

const benefits = computed(() => props.productData.attributes.benefits)
const descriptionHtml = computed(() => props.productData.attributes.descriptionHtml)
const recommendedFor = computed(() => props.productData.attributes.recommendedFor)

const showFull = ref(false)
</script>

<template>
  <div class="flex flex-col items-stretch md:flex-row">
    <ProductTextStrong class="min-w-full md:min-w-[143px] lg:min-w-[33%]" text="О товаре" />

    <div class="mt-2 md:mt-0">
      <div class="relative">
        <div
          :class="[
            'relative transition-all duration-300',
            showFull ? 'max-h-none' : 'max-h-[180px] overflow-hidden'
          ]"
        >
          <HtmlArea
            v-if="descriptionHtml"
            class="!text-sm !leading-[1.43] tracking-[-0.01em] md:!text-base md:!leading-normal"
            :plain-html="descriptionHtml"
          />
          <Notification v-else status="info">
            Нет описания.
          </Notification>

          <div
            v-if="!showFull && descriptionHtml && descriptionHtml.length > 500"
            class="pointer-events-none absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-white to-transparent"
          />
        </div>
      </div>

      <ProductGrayButton
        v-if="descriptionHtml && descriptionHtml.length > 500"
        class="mt-4 md:mt-5"
        :title="showFull ? 'Скрыть' : 'Читать подробнее'"
        @click.prevent="showFull = !showFull"
      />

      <template v-if="benefits">
        <ProductTextStrong class="my-4" text="Чем полезен" />
        <pre class="pre-wrap">{{ benefits }}</pre>
      </template>

      <template v-if="recommendedFor">
        <ProductTextStrong class="my-4" text="Кому рекомендуется" />
        <pre class="pre-wrap">{{ recommendedFor }}</pre>
      </template>
    </div>
  </div>
</template>
